
import { SiriusBaseComponent } from 'sirius-framework';
import { Component } from '@angular/core';

@Component({
    selector: 'inner-menu',
    templateUrl: './inner-menu.component.html',
    styleUrls: ['./inner-menu.component.css']
})
export class InnerMenuComponent extends SiriusBaseComponent<any> {
    OnInit() {
    }
}
